import { createSelector } from 'reselect'

import { selectGlobalPartnerState } from './selectGlobalPartnerState'

export const selectGPLoadingStatus = createSelector(
  [selectGlobalPartnerState],
  (state) => state.status
)
